module.exports = __webpack_public_path__ + "img/面试.480d35cc.png";